import SiteLayout from "@/components/feature/SiteLayout";
import Seo from "@/components/base/Seo";
import FaqAccordion from "@/components/feature/FaqAccordion";
import ArticleHeader from "@/pages/blog/components/ArticleHeader";
import ArticleContent from "@/pages/blog/components/ArticleContent";
import ArticleSidebar from "@/pages/blog/components/ArticleSidebar";
import ArticleCtaBlock from "@/pages/blog/components/ArticleCtaBlock";
import ArticleAuthor from "@/pages/blog/components/ArticleAuthor";
import RelatedPosts from "@/pages/blog/components/RelatedPosts";
import RelatedByTheme from "@/pages/blog/components/RelatedByTheme";
import BlogNewsletter from "@/pages/blog/components/BlogNewsletter";
import { getAuthor, getCategory, type BlogPost } from "@/pages/blog/blogData";

export default function ArticleView({ post }: { post: BlogPost }) {
  const category = getCategory(post.category);
  const author = getAuthor(post.author);
  const breadcrumbs = [
    { name: "Início", path: "/" },
    { name: "Blog", path: "/blog" },
    ...(category ? [{ name: category.name, path: `/blog/${category.slug}` }] : []),
    { name: post.h1, path: `/blog/${post.slug}` },
  ];

  return (
    <SiteLayout>
      <Seo
        title={post.metaTitle}
        description={post.metaDescription}
        keywords={[post.focusKeyword, ...post.keywords].join(", ")}
        path={`/blog/${post.slug}`}
        image={post.image}
        article={{
          headline: post.h1,
          description: post.metaDescription,
          image: post.image,
          datePublished: post.publishedAt,
          dateModified: post.updatedAt,
          author: author.name,
          section: category?.name ?? "Blog",
        }}
        breadcrumbs={breadcrumbs}
        faqs={post.faqs}
      />

      <ArticleHeader post={post} />

      <div className="bg-background-50 py-12 md:py-16">
        <div className="mx-auto max-w-7xl px-4 md:px-8">
          <div className="grid grid-cols-1 gap-10 lg:grid-cols-[minmax(0,1fr)_320px]">
            <div className="min-w-0">
              <ArticleContent post={post} />

              {post.faqs.length > 0 ? (
                <div className="mt-14">
                  <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
                    Perguntas frequentes
                  </h2>
                  <div className="mt-6">
                    <FaqAccordion items={post.faqs} />
                  </div>
                </div>
              ) : null}

              <RelatedByTheme post={post} />

              <div className="mt-12">
                <ArticleCtaBlock cta={post.cta} />
              </div>

              <div className="mt-8">
                <ArticleAuthor post={post} />
              </div>
            </div>

            <div className="lg:sticky lg:top-24 lg:self-start">
              <ArticleSidebar post={post} />
            </div>
          </div>
        </div>
      </div>

      <RelatedPosts post={post} />
      <BlogNewsletter />
    </SiteLayout>
  );
}